/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocioConfiguracion } from '../../conexiones';
import ITiposUnidades from './entidades/tiposUnidades';

export default class ModeloTiposUnidades {
    public consultarTiposUnidades() {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() => negocioConfiguracion.get('TipoUnidad/ConsultarListaTipoUnidad'));
    }
    public crearTiposUnidades(tiposUnidades: ITiposUnidades) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocioConfiguracion.post('TipoUnidad/GuardarTipoUnidad', tiposUnidades)
        );
    }
    public editarTiposUnidades(tiposUnidades: ITiposUnidades) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocioConfiguracion.put('TipoUnidad/EditarTipoUnidad', tiposUnidades)
        );
    }
    public eliminarTiposUnidades(tiposUnidades: ITiposUnidades) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocioConfiguracion.delete('TipoUnidad/EliminarTipoUnidad', tiposUnidades)
        );
    }

    public consultarTiposUnidadesPorFiltro(tiposUnidades: Partial<ITiposUnidades>) {
        return manejadorRest<IRespuesta<ITiposUnidades>>(() =>
            negocioConfiguracion.post('TipoUnidad/ConsultarListaTipoUnidadPorFiltro', tiposUnidades)
        );
    }
}
